<!-- v1 - in use -->
<template>
  <div id="homeTestimonials">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="50"
      :lazy="true"
      navigation
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="block in sectionBlocks">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-5 image-col">
            <!-- mobile image -->
            <div
              v-if="block.image_mobile"
              class="testimonial-img img-responsive d-sm-none"
              :style="{ backgroundImage: `url(${block.image_mobile})` }"
            >
              <a :href="block.link_1_url" v-if="block.link_1_url"></a>
            </div>
            <!-- desktop image -->
            <div
              :class="{ 'd-none d-sm-block': block.image_mobile }"
              class="testimonial-img img-responsive"
              :style="{ backgroundImage: `url(${block.image})` }"
            >
              <a :href="block.link_1_url" v-if="block.link_1_url"></a>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-7 text-col">
            <div class="content">
              <div class="stars"></div>
              <blockquote>
                <p :class="{ 'long-quote': block.long_quote }">
                  {{ block.quote }}
                </p>
                <cite>{{ block.author }}</cite>
              </blockquote>
              <a
                :href="block.link_1_url"
                class="btn btn-home"
                v-if="block.link_1_url"
                >{{ block.link_1_text }}</a
              >
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script src="./ctrl-home-testimonials.js"></script>
